import { defineComponent as _defineComponent } from 'vue'
import { useVModel } from '@vueuse/core';
import BCXActionBoxMessageBox from '@/components/molecules/BCXActionBoxMessageBox.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendationMessageBox',
  props: {
  value: {
    type: String,
    default: ''
  },
  disabled: Boolean,
},
  setup(__props) {

const props = __props;



const vModel = useVModel(props);


return { __sfc: true,props, vModel, BCXActionBoxMessageBox }
}

})